var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Map',{attrs:{"id":"map","overrideStyles":{ height: 'calc(100vh - 3rem)' },"drawing":true,"options":{
    controls: function (defs) { return defs.filter(function (def) { return def.constructor.name !== 'FullScreen'; }); },
    units: _vm.systemOfMeasurement,
  },"wkt":_vm.mapLayers,"geojson":{
    title: 'areas',
    url: _vm.areaGeoJSON,
    color: 'grey',
  }},on:{"update-wkt":_vm.updateMovement}})}
var staticRenderFns = []

export { render, staticRenderFns }